module.exports = __webpack_public_path__ + "img/Zimi-logo.19ecdcdf.png";